import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { getTrackingGuide } from 'redux/actions/shipping.actions';

import TrackingGuide from 'views/TrackingGuide';

const TrackingGuideContainer = (props) => {
  const {
    guideNumber, getTrackingGuideAction, trackingGuide, guide, loading,
  } = props;

  useEffect(() => {
    if (guideNumber) getTrackingGuideAction(guideNumber);
    return () => getTrackingGuideAction('');
  }, [guideNumber, getTrackingGuideAction]);

  return (
    <TrackingGuide
      guideNumber={guideNumber}
      trackingGuide={trackingGuide}
      guide={guide}
      loading={loading}
    />
  );
};

const mapStateToProps = (state, props) => ({
  guideNumber: props.match.params.guideNumber,
  trackingGuide: state.shipping.trackingGuide,
  guide: state.shipping.guide,
  loading: state.shipping.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getTrackingGuideAction: bindActionCreators(getTrackingGuide, dispatch),
});

TrackingGuideContainer.defaultProps = {
  trackingGuide: null,
  guide: null,
};

TrackingGuideContainer.propTypes = {
  guideNumber: PropTypes.string.isRequired,
  getTrackingGuideAction: PropTypes.func.isRequired,
  trackingGuide: PropTypes.object,
  guide: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackingGuideContainer);
